/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alert_Icy_Dragonfly_FileInputs */

const fr_alert_icy_dragonfly_file = /** @type {(inputs: Alert_Icy_Dragonfly_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de téléphone modifié`)
};

/**

* @param {Alert_Icy_Dragonfly_FileInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const alert_icy_dragonfly_file = /** @type {((inputs?: Alert_Icy_Dragonfly_FileInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alert_Icy_Dragonfly_FileInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_alert_icy_dragonfly_file(inputs)
});